import { HEADERS_JSON } from "@/common/api/constants";
import { CommonFetchRequest, FetchGetPlainRequest } from "@/common/api/types";
import { handleErrorMessage, responseHandler } from "@/common/api/utils";
import { API_URL, MANUAL_URL } from "@/config";
import { ProfilePostProps } from "@/entities/profile/api/types";
import { ApprovePhoneProps, EditPhoneProps } from "@/entities/profile/types";

export const postEditPhone: CommonFetchRequest<
  EditPhoneProps & {
    token: string | null;
  }
> = async ({ setErrorMessage, phone, iin, token }) => {
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
        ...HEADERS_JSON,
      }
    : HEADERS_JSON;

  const response = await fetch(`${API_URL}/change-phone`, {
    method: "POST",
    headers,
    body: JSON.stringify({ phone, iin }),
  });

  return await responseHandler({
    response,
    setErrorMessage,
    customHandler: handleErrorMessage,
  });
};

export const postApprovePhoneCode: CommonFetchRequest<
  ApprovePhoneProps & {
    token: string | null;
  }
> = async ({ setErrorMessage, token, code, iin }) => {
  const headers = token
    ? {
        Authorization: `Bearer ${token}`,
        ...HEADERS_JSON,
      }
    : HEADERS_JSON;

  const response = await fetch(`${API_URL}/approve-new-phone`, {
    method: "POST",
    headers,
    body: JSON.stringify({ code, iin }),
  });

  return await responseHandler({
    response,
    setErrorMessage,
    customHandler: handleErrorMessage,
  });
};

export const postBankAccount: CommonFetchRequest<{
  token: string;
  bankAccount: string;
}> = async ({ setErrorMessage, token, bankAccount }) => {
  const response = await fetch(`${API_URL}/cabinet/add-bank-account`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
    body: JSON.stringify({ iban: bankAccount }),
  });

  return await responseHandler({
    response,
    setErrorMessage,
    customHandler: handleErrorMessage,
  });
};

export const fetchProfile: CommonFetchRequest<{ token: string }> = async ({
  setErrorMessage,
  token,
}) => {
  const response = await fetch(`${API_URL}/cabinet/profile`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
  });
  return await responseHandler({ response, setErrorMessage });
};

export const postProfile: CommonFetchRequest<{
  token: string;
  profile: ProfilePostProps;
}> = async ({ setErrorMessage, token, profile }) => {
  const response = await fetch(`${API_URL}/cabinet/profile`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
    body: JSON.stringify(profile),
  });
  return await responseHandler({ response, setErrorMessage });
};

export const fetchFamilyStatuses: FetchGetPlainRequest<
  Record<string, string> | undefined
> = async (setErrorMessage) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${MANUAL_URL}/family-status`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
  });
  const result = await responseHandler({ response, setErrorMessage });
  return await result?.json();
};

export const fetchGenderStatuses: FetchGetPlainRequest<
  Record<string, string> | undefined
> = async (setErrorMessage) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${MANUAL_URL}/gender`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
  });
  const result = await responseHandler({ response, setErrorMessage });
  return await result?.json();
};

export const fetchRelativeStatuses: FetchGetPlainRequest<
  Record<string, string> | undefined
> = async (setErrorMessage) => {
  const token = localStorage.getItem("token");
  const response = await fetch(`${MANUAL_URL}/relative-type`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      ...HEADERS_JSON,
    },
  });
  const result = await responseHandler({ response, setErrorMessage });
  return await result?.json();
};
